import React, { useEffect, useMemo, useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CommonDataTable from "../../components/CommonDataTable";

const rawColumns = [
    { field: "workstationId", headerName: "Workstation ID" },
    { field: "workstationType", headerName: "Type" },
    { field: "workstationLocation", headerName: "Location" },
    { field: "createdBy", headerName: "Created By" },
    { field: "createdDate", headerName: "Created Date" },
    { field: "updatedBy", headerName: "Updated By" },
    { field: "updatedDate", headerName: "Updated Date" }
];

export default function WorkstationList({
    workstation,
    page,
    pageSize,
    setPage,
    setPageSize,
    onCreateClick,
    onView,
    onEdit,
    onRefresh
}) {

    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const [menuRow, setMenuRow] = useState(null);
    const [tableRows, setTableRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    useEffect(() => {
        if (workstation?.data?.length) {

            const formatted = workstation.data.map(item => ({
                id: item._id,
                ...item,
                __original: item
            }));

            setTableRows(formatted);
            setTotalCount(workstation.meta?.total || 0);
        }
    }, [workstation]);

    const actionColumn = {
        field: "__actions",
        headerName: "",
        width: 80,
        sortable: false,
        renderCell: (params) => (
            <IconButton
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    setMenuAnchorEl(e.currentTarget);
                    setMenuRow(params.row);
                }}
            >
                <MoreVertIcon fontSize="small" />
            </IconButton>
        )
    };

    const allColumns = useMemo(
        () => [actionColumn, ...rawColumns],
        [actionColumn]
    );

    return (
        <>
            <CommonDataTable
                checkboxSelection
                allPossibleColumns={allColumns}
                initialVisible={allColumns.map(c => c.field)}
                initialRows={tableRows}
                showCreateButton
                createButtonText="Create New"
                onCreateClick={onCreateClick}
                page={page}
                pageSize={pageSize}
                rowCount={totalCount}
                onPageChange={setPage}
                onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0);
                }}
                forInventory={true}
                onDataRefresh={onRefresh}
                
            />

            <Menu
                open={!!menuAnchorEl}
                anchorEl={menuAnchorEl}
                onClose={() => setMenuAnchorEl(null)}
            >
                <MenuItem onClick={() => onView(menuRow.__original)}>
                    View
                </MenuItem>
                <MenuItem onClick={() => onEdit(menuRow.__original)}>
                    Edit
                </MenuItem>
            </Menu>
        </>
    );
}